import { InputAdornment, Link } from "@mui/material";
import { textFieldStyle, zipCodeLinkStyle } from "./CouponStyles";
import { ControlledTextField, ControlledTextFieldProps } from "../forms/ControlledTextField";
import { CHECKOUT_MAXLEN } from "../../utils/checkoutFieldMaxLengths";

export const ZipCodeField: React.FC<ControlledTextFieldProps> = (props) => (
  <ControlledTextField
    {...props}
    fullWidth
    label={"Código Postal"}
    sx={{mb: 2, ...textFieldStyle}}
    inputProps={{
      maxLength: CHECKOUT_MAXLEN.vchCP,
      inputMode: "numeric",
      pattern: "[0-9]*",
      ...(props.inputProps || {}),
    }}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <Link href="https://www.correoargentino.com.ar/formularios/cpa" target="_blank" sx={zipCodeLinkStyle}>
            No sé mi CP
          </Link>
        </InputAdornment>
      ),
    }}
  />
);














